/*/////////////////////////////////////////////////////////////////////
// Copyright (c) Autodesk, Inc. All rights reserved
// Written by Autodesk Design Automation team for Inventor
//
// Permission to use, copy, modify, and distribute this software in
// object code form for any purpose and without fee is hereby granted,
// provided that the above copyright notice appears in all copies and
// that both that copyright notice and the limited warranty and
// restricted rights notice below appear in all supporting
// documentation.
//
// AUTODESK PROVIDES THIS PROGRAM "AS IS" AND WITH ALL FAULTS.
// AUTODESK SPECIFICALLY DISCLAIMS ANY IMPLIED WARRANTY OF
// MERCHANTABILITY OR FITNESS FOR A PARTICULAR USE.  AUTODESK, INC.
// DOES NOT WARRANT THAT THE OPERATION OF THE PROGRAM WILL BE
// UNINTERRUPTED OR ERROR FREE.
/////////////////////////////////////////////////////////////////////

import React, { Component } from 'react';
import {connect} from 'react-redux';
import ProjectAccountSwitcher from '@hig/project-account-switcher';
import { fetchProjects, updateActiveProject } from '../actions/projectListActions';
import { updateActiveTabIndex, invalidateDrawing } from '../actions/uiFlagsActions';
import { fetchParameters } from '../actions/parametersActions';
import {addLog} from '../actions/notificationActions';
import './projectSwitcher.css';

export class ProjectSwitcher extends Component {

    constructor(props) {
        super(props);
        this.onProjectClick = this.onProjectClick.bind(this);
    }

    componentDidMount() {
        this.props.fetchProjects();
    }

    onProjectClick(event) {
        // depending on where exactly you click in the row (the anchor text vs outside of the text),
        // event.target.innerText is not sufficient match for the id. event.target.lastChild.textContent seems to be fine.
        const id = event.target.lastChild.textContent;
        this.props.updateActiveProject(id);
        // mark drawing as not valid if any available
        this.props.invalidateDrawing();
        // switch to the model tab
        this.props.updateActiveTabIndex(1);
        //this.props.fetchParameters(id);
        this.props.addLog('Selected: ' + id);
    }

    render() {
        return (
            <span id="PAS">
            <ProjectAccountSwitcher
                defaultProject={null}
                activeProject={this.props.projectList.activeProjectId}
                projects={this.props.projectList.projects}
                projectTitle="Projects"
                onClick={this.onProjectClick}
            />
            </span>
        );
    }
}

*//* istanbul ignore next *//*
export default connect(function (store){
    return {
      projectList: store.projectList
    };
  }, { fetchProjects, fetchParameters, updateActiveProject, updateActiveTabIndex, addLog, invalidateDrawing } )(ProjectSwitcher);
*/


/////////////////////////////////////////////////////////////////////
// Copyright (c) Autodesk, Inc. All rights reserved
// Written by Autodesk Design Automation team for Inventor
/////////////////////////////////////////////////////////////////////

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fetchProjects } from '../actions/projectListActions';

// Ten komponent tylko �aduje projekty, ale nic nie renderuje.
// Dzi�ki temu lista w zak�adce "Projects" dzia�a,
// a dropdown w prawym g�rnym rogu znika.

export class ProjectSwitcher extends Component {
    componentDidMount() {
        // dalej pobieramy list� projekt�w przy starcie aplikacji
        this.props.fetchProjects();
    }

    render() {
        // nic nie rysujemy (brak dropdownu w toolbarze)
        return null;
    }
}

/* istanbul ignore next */
export default connect(
    function (store) {
        return {};
    },
    { fetchProjects }
)(ProjectSwitcher);
